// import React, { useState, useEffect, useId } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import "./createques.css";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import SelectedDropdownValues from "./SelectedDropdownValues";
// import { fetchClassData } from "../../../Redux/StudentRegistration/classSlice";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import NotesIcon from "./../../../Assets/Images/CommanImages/grommet-icons_notes.png";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorIcon from "./../../../Assets/Images/CommanImages/Error.png";
// import SuccessImg from "./../../../Assets/Images/CommanImages/Informative.png";
// import MultiSeledDropdown from "../MultiDropdown/MultiSeledDropdown";
// import MultiProgress from "../MultiProgressBar/MultiProgress";
// import { fetchScopeData } from "../../../Redux/Scope/ScopeSlice";
// import { API_BASE_URL } from "../../../Config/Config";
// import FacultySelector from "../MultipleAssignCreator/FacultySelector";
// import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
// import EndPoints from "../../../Api/Endpoints";
// import { POST, GET } from "../../../Api/HttpsMethods";

// function CreateQuesPaper({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg, setNoTimeSet, }) {
//   const [questionPaperType, setQuestionPaperType] = useState(null);
//   const [selectedtestSeriesId, setSelectedTestSeriesID] = useState(1);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { coursesdata = [] } = useSelector((state) => state.course) || {};
//   const { classData = [] } = useSelector((state) => state.classname) || {};
//   const { scopeData = [] } = useSelector((state) => state.scopes) || {};
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [selectedClass, setSelectedClass] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [expandedSubjects, setExpandedSubjects] = useState({});
//   const [chapterData, setChapterData] = useState({});
//   const [checkedSubjects, setCheckedSubjects] = useState({});
//   const [isOpen, setIsOpen] = useState(true);
//   const [isOpenSubject, setIsOpenSubject] = useState(true);
//   const [totalQuestionCount, setTotalQuestionCount] = useState(0);
//   const [QuestionTypeId, setQuestionTypeID] = useState(null);
//   const [selectedChapters, setSelectedChapters] = useState({});
//   const [difficultyDistributions, setDifficultyDistributions] = useState({});
//   const [selectScope, setSelectedScope] = useState(null);
//   const [openNotes, setOpenNotes] = useState({});
//   const [batchData, setBatchData] = useState([]);
//   const [selectedBatch, setSelectedBatch] = useState([]);
//   const [selectedCities, setSelectedCities] = useState([]);
//   const [cityData, setCityData] = useState([]);
//   const [selectedStates, setSelectedStates] = useState([]);
//   const [stateData, setStateData] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState([]);
//   const [selectedZone, setSelectedZone] = useState([]);
//   const [selectedRegion, setSelectedRegion] = useState([]);
//   const [branchData, setBranchData] = useState([]);
//   const [zoneData, setZoneData] = useState([]);
//   const [regionData, setRegionData] = useState([]);
//   const [selectedFaculties, setSelectedFaculties] = useState([]);
//   const [selectedAssigReviewerFaculties, setSelectedAssigReviewerFaculties] = useState([]);
//   const [selectedCreatorsBySubject, setSelectedCreatorsBySubject] = useState({});
//   const [selectedReviewersBySubject, setSelectedReviewersBySubject] = useState({});
//   const [dropdownKey, setDropdownKey] = useState(0);
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//   const userId = dataClient && dataClient.client_schema_name[6][0].user_id;
//   const [specialInstructions, setSpecialInstructions] = useState({});
//   const [patternsData, setPatternsData] = useState([]);
//   const [selectedPatternDetails, setSelectedPatternDetails] = useState(null);
//   const [selectedPattern, setSelectedPattern] = useState(null);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [createdQuesPaperId, setCreatedQuesPaperId] = useState(null);
//   const accessToken = localStorage.getItem("other");
//   const [patternNameError, setPatternNameError] = useState(false);
//   const [patternDescError, setPatternDescError] = useState(false);

//   useEffect(() => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       client_branch_id: clientBranchId,
//       created_by: userName,
//     }));
//   }, [clientBranchId, userName]);

//   const [showPatternPopup, setShowPatternPopup] = useState(false);
//   const [patternName, setPatternName] = useState("");
//   const [patternDesc, setPatternDesc] = useState("");

//   useEffect(() => {
//     dispatch(fetchClassData());
//     dispatch(fetchCourseData());
//     dispatch(fetchScopeData());
//   }, [dispatch]);


//   // ─── CHANGED: deduplicate by subject_superset_id, display subject_superset_name ───
//   useEffect(() => {
//     const fetchSubjectsByCourse = async () => {
//       if (!selectedCourse) {
//         setSubjects([]);
//         return;
//       }
//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourse}`;
//         const data = await GET.withToken(API_ENDPOINT);

//         if (!Array.isArray(data)) {
//           setSubjects([]);
//           return;
//         }

//         // Deduplicate by subject_superset_id; map superset fields onto subject_id/subject_name
//         // so all downstream state, handlers, and POST payload automatically use subject_superset_id
//         const seen = new Set();
//         const deduplicated = data.reduce((acc, item) => {
//           if (!seen.has(item.subject_superset_id)) {
//             seen.add(item.subject_superset_id);
//             acc.push({
//               subject_id: item.subject_superset_id,       // superset_id used as key throughout
//               subject_name: item.subject_superset_name,   // superset_name shown in UI
//               subject_desc: item.subject_superset_desc,
//             });
//           }
//           return acc;
//         }, []);

//         setSubjects(deduplicated);
//       } catch (error) {
//         console.error("Error fetching subjects:", error);
//         setSubjects([]);
//       }
//     };
//     fetchSubjectsByCourse();
//   }, [selectedCourse]);


//   const handleSubjectCheck = async (subjectId) => {
//     let shouldFetchChapters = false;
//     setCheckedSubjects((prev) => {
//       const isChecked = !prev[subjectId];
//       const chapters = chapterData[subjectId] || [];

//       if (isChecked) {
//         setSelectedChapters((prevChapters) => ({
//           ...prevChapters,
//           [subjectId]: chapters.map((ch) => ch.chapter_id),
//         }));

//         setFormData((prevFormData) => {
//           const existingSubject = prevFormData.subjects.find(
//             (s) => s.subject_superset_id === subjectId
//           );

//           let easy = 0,
//             medium = 0,
//             tough = 0;

//           if (questionPaperType === 2) {
//             easy = difficultyDistributions[subjectId]?.firstSegment || 0;
//             medium = difficultyDistributions[subjectId]?.secondSegment || 0;
//             tough = difficultyDistributions[subjectId]?.calculatedValue || 0;
//           }

//           return {
//             ...prevFormData,
//             subjects: [
//               ...prevFormData.subjects.filter(
//                 (s) => s.subject_superset_id !== subjectId
//               ),
//               {
//                 subject_superset_id: subjectId,
//                 easy,
//                 medium,
//                 tough,
//                 special_inst: existingSubject?.special_inst || "",
//                 chapters: chapters.map((ch) => ({
//                   chapter_id: ch.chapter_id,
//                 })),
//               },
//             ],
//           };
//         });
//       } else {
//         setSelectedChapters((prevChapters) => ({
//           ...prevChapters,
//           [subjectId]: [],
//         }));

//         setExpandedSubjects((prevExpanded) => ({
//           ...prevExpanded,
//           [subjectId]: false,
//         }));

//         setFormData((prevFormData) => ({
//           ...prevFormData,
//           subjects: prevFormData.subjects.filter(
//             (s) => s.subject_superset_id !== subjectId
//           ),
//         }));
//       }

//       if (!chapterData[subjectId]) {
//         shouldFetchChapters = true;
//       }

//       return { ...prev, [subjectId]: isChecked };
//     });

//     if (!shouldFetchChapters) return;

//     try {
//       // ─── CHANGED: use subject_superset_id param ───
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`;
//       const data = await GET.withToken(API_ENDPOINT);

//       if (!Array.isArray(data)) {
//         console.error("Expected array but got:", data);
//         return;
//       }

//       setChapterData((prev) => ({
//         ...prev,
//         [subjectId]: data,
//       }));

//       setSelectedChapters((prevChapters) => ({
//         ...prevChapters,
//         [subjectId]: data.map((ch) => ch.chapter_id),
//       }));
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//     }
//   };


//   const toggleExpandSubject = async (subjectId) => {
//     if (!checkedSubjects[subjectId]) return;
//     setExpandedSubjects((prev) => ({
//       ...prev,
//       [subjectId]: !prev[subjectId],
//     }));

//     if (chapterData[subjectId]) return;

//     try {
//       // ─── CHANGED: use subject_superset_id param ───
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`;
//       const data = await GET.withToken(API_ENDPOINT);

//       if (!Array.isArray(data)) {
//         console.error("Expected array but got:", data);
//         return;
//       }

//       setChapterData((prev) => ({
//         ...prev,
//         [subjectId]: data,
//       }));

//       setSelectedChapters((prevChapters) => ({
//         ...prevChapters,
//         [subjectId]: data.map((ch) => ch.chapter_id),
//       }));
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//     }
//   };

//   const syncSubjectFromChapters = (subjectId, nextChapterIds) => {
//     setCheckedSubjects((prev) => ({
//       ...prev,
//       [subjectId]: nextChapterIds.length > 0,
//     }));
//     setFormData((prev) => {
//       const filtered = prev.subjects.filter((s) => s.subject_superset_id !== subjectId);

//       if (nextChapterIds.length === 0) {
//         return { ...prev, subjects: filtered };
//       }
//       const existing = prev.subjects.find((s) => s.subject_superset_id === subjectId);
//       const dist = difficultyDistributions[subjectId] || {};
//       return {
//         ...prev,
//         subjects: [
//           ...filtered,
//           {
//             subject_superset_id: subjectId,
//             easy: existing?.easy ?? dist.firstSegment ?? 0,
//             medium: existing?.medium ?? dist.secondSegment ?? 0,
//             tough: existing?.tough ?? dist.calculatedValue ?? 0,
//             special_inst: existing?.special_inst ?? specialInstructions[subjectId] ?? "",
//             chapters: nextChapterIds.map((id) => ({ chapter_id: id })),
//           },
//         ],
//       };
//     });
//   };


//   const handleChapterCheck = (subjectId, chapterId) => {
//     setSelectedChapters((prev) => {
//       const current = prev[subjectId] || [];
//       const next = current.includes(chapterId)
//         ? current.filter((id) => id !== chapterId)
//         : [...current, chapterId];
//       syncSubjectFromChapters(subjectId, next);

//       return { ...prev, [subjectId]: next };
//     });
//   };

//   const handleSelectAllChapters = (subjectId) => {
//     const total = chapterData[subjectId]?.length || 0;
//     const allSelected = (selectedChapters[subjectId]?.length || 0) === total;

//     const next = allSelected
//       ? []
//       : chapterData[subjectId].map((ch) => ch.chapter_id);

//     setSelectedChapters((prev) => ({ ...prev, [subjectId]: next }));
//     syncSubjectFromChapters(subjectId, next);
//   };

//   const toggleAccordion = () => {
//     setIsOpen(!isOpen);
//   };

//   const toggleAccordionSubjects = () => {
//     setIsOpenSubject(!isOpenSubject);
//   };

//   const [manuallyUpdatedSubjects, setManuallyUpdatedSubjects] = useState({});

//   const handleQuestionCountChange = (subjectId, value) => {
//     if (/^\d*$/.test(value)) {
//       const parsedValue = parseInt(value || 0, 10);

//       setManuallyUpdatedSubjects((prev) => ({
//         ...prev,
//         [subjectId]: true,
//       }));

//       setSubjects((prevSubjects) =>
//         prevSubjects.map((subject) =>
//           subject.subject_id === subjectId
//             ? { ...subject, questionCount: parsedValue }
//             : subject
//         )
//       );

//       const easy = Math.floor(parsedValue / 3);
//       const medium = Math.floor(parsedValue / 3);
//       const tough = parsedValue - (easy + medium);

//       const newDistribution = {
//         firstSegment: easy,
//         secondSegment: medium,
//         calculatedValue: tough,
//       };

//       setDifficultyDistributions((prev) => ({
//         ...prev,
//         [subjectId]: newDistribution,
//       }));

//       setFormData((prevFormData) => {
//         const updatedSubjects = prevFormData.subjects.map((subject) => {
//           if (subject.subject_superset_id === subjectId) {
//             return {
//               ...subject,
//               easy,
//               medium,
//               tough,
//             };
//           }
//           return subject;
//         });

//         return {
//           ...prevFormData,
//           subjects: updatedSubjects,
//         };
//       });

//       const newTotal = subjects.reduce((acc, subject) => {
//         const count =
//           subject.subject_id === subjectId
//             ? parsedValue
//             : parseInt(subject.questionCount || 0, 10);
//         return acc + count;
//       }, 0);
//       setTotalQuestionCount(newTotal);
//     }
//   };


//   const handleSliderChange = (subjectId, values) => {
//     setDifficultyDistributions((prev) => ({
//       ...prev,
//       [subjectId]: values,
//     }));

//     setFormData((prevFormData) => {
//       const updatedSubjects = prevFormData.subjects.map((subject) => {
//         if (subject.subject_superset_id === subjectId) {
//           return {
//             ...subject,
//             easy: values.firstSegment || 0,
//             medium: values.secondSegment || 0,
//             tough: values.calculatedValue || 0,
//           };
//         }
//         return subject;
//       });

//       return {
//         ...prevFormData,
//         subjects: updatedSubjects,
//       };
//     });
//   };

//   const toggleNotesInput = (subjectId) => {
//     if (!checkedSubjects[subjectId]) return;
//     setOpenNotes((prev) => ({
//       ...prev,
//       [subjectId]: !prev[subjectId],
//     }));

//     if (!specialInstructions[subjectId]) {
//       setSpecialInstructions((prev) => ({
//         ...prev,
//         [subjectId]: "",
//       }));
//     }
//   };

//   const [formData, setFormData] = useState({
//     ques_paper_name: "",
//     description: "",
//     ques_paper_type: QuestionTypeId,
//     course_id: selectedCourse,
//     ques_paper_series: selectedPattern,
//     due_date: "",
//     test_series_id: selectedtestSeriesId,
//     client_branch_id: clientBranchId,
//     created_by: userName,
//     status: 1,
//     guidelines: "",
//     classes: selectedClass,
//     subjects: [
//       {
//         subject_superset_id: 0,
//         easy: 0,
//         medium: 0,
//         tough: 0,
//         special_inst: "",
//         chapters: [],
//       },
//     ],
//     assign_creators: [
//       {
//         subject_superset_id: 0,
//         user_ids: selectedFaculties.map((faculty) => faculty.user_id),
//       },
//     ],
//     assign_reviewers: [
//       { subject_superset_id: 0, user_id: selectedAssigReviewerFaculties.user_id },
//     ],
//   });


//   const ensureAllChaptersFetched = async () => {
//     // Start with a snapshot of what's already in state
//     const resolvedChapters = { ...selectedChapters };

//     const subjectIdsToFetch = Object.keys(checkedSubjects)
//       .filter((sid) => checkedSubjects[sid])
//       .filter((sid) => !chapterData[sid]);

//     const promises = subjectIdsToFetch.map(async (sid) => {
//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${sid}`;
//         const data = await GET.withToken(API_ENDPOINT);
//         const chapters = Array.isArray(data) ? data : [];
//         const chapterIds = chapters.map((c) => c.chapter_id);

//         // Update state for future renders
//         setChapterData((prev) => ({ ...prev, [sid]: chapters }));
//         setSelectedChapters((prev) => ({ ...prev, [sid]: chapterIds }));

//         // Also record in our local snapshot so we can use it immediately
//         resolvedChapters[sid] = chapterIds;
//       } catch (error) {
//         console.error(`Error fetching chapters for subject ${sid}:`, error);
//         setChapterData((prev) => ({ ...prev, [sid]: [] }));
//         setSelectedChapters((prev) => ({ ...prev, [sid]: [] }));
//         resolvedChapters[sid] = [];
//       }
//     });

//     await Promise.all(promises);

//     // Return the fully-resolved map so the caller can use it synchronously
//     return resolvedChapters;
//   };

//   const handleSubmit = async () => {
//     let errorMessage = "";
//     let warningMessage = "";

//     if (!formData.course_id) {
//       errorMessage = "Course selection is required.";
//     } else if (!formData.ques_paper_type) {
//       errorMessage = "Question Paper Type is required.";
//     } else if (!formData.ques_paper_name) {
//       errorMessage = "Test Name is required.";
//     } else if (!formData.due_date) {
//       errorMessage = "Due Date is required.";
//     } else if (!formData.description) {
//       errorMessage = "Description is required.";
//     } else {
//       const dueDate = new Date(formData.due_date);
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       dueDate.setHours(0, 0, 0, 0);

//       if (isNaN(dueDate.getTime())) {
//         errorMessage = "Please enter a valid due date.";
//       } else if (dueDate < today) {
//         errorMessage = "Test Date cannot be in the past.";
//       }
//     }

//     const selectedSubjects = subjects.filter(
//       (subject) => checkedSubjects[subject.subject_id]
//     );
//     if (!errorMessage && selectedSubjects.length === 0) {
//       errorMessage = "At least one subject must be selected.";
//     }

//     const hasZeroQuestionCount = selectedSubjects.some(
//       (subject) => (parseInt(subject.questionCount, 10) || 0) === 0
//     );
//     if (!errorMessage && hasZeroQuestionCount) {
//       errorMessage = "Question count cannot be zero for any selected subject.";
//     }

//     const hasLessThanThreeQuestions = selectedSubjects.some(
//       (subject) => {
//         const count = parseInt(subject.questionCount, 10) || 0;
//         return count > 0 && count < 3;
//       }
//     );

//     if (!errorMessage && hasLessThanThreeQuestions) {
//       errorMessage = "Question count must be at least 3 for each selected subject.";
//     }

//     if (!errorMessage && formData.ques_paper_type === 1) {
//       const hasExcessiveDPP = selectedSubjects.some(
//         (subject) => (parseInt(subject.questionCount, 10) || 0) > 50
//       );

//       if (hasExcessiveDPP) {
//         warningMessage +=
//           (warningMessage ? "\n" : "") +
//           "DPP should not have more than 50 questions per subject.";
//       }
//     }

//     const assignCreators = selectedSubjects.map((subject) => ({
//       subject_superset_id: subject.subject_id,
//       user_ids: (selectedCreatorsBySubject[subject.subject_id] || []).map(
//         (faculty) => faculty.user_id
//       ),
//     }));

//     const hasSubjectWithoutCreator = assignCreators.some(
//       (subject) => subject.user_ids.length === 0
//     );
//     if (!errorMessage && hasSubjectWithoutCreator) {
//       errorMessage =
//         "Each selected subject must have at least one assigned creator.";
//     }

//     const hasSubjectWithoutReviewer = selectedSubjects.some(
//       (subject) => {
//         const reviewers = selectedReviewersBySubject[subject.subject_id] || [];
//         return reviewers.length === 0;
//       }
//     );

//     if (!errorMessage && hasSubjectWithoutReviewer) {
//       errorMessage = "Each selected subject must have at least one assigned reviewer.";
//     }

//     const assignReviewers = selectedSubjects
//       .map((subject) => {
//         const reviewers = selectedReviewersBySubject[subject.subject_id] || [];
//         if (reviewers.length > 0) {
//           return {
//             subject_superset_id: subject.subject_id,
//             user_id: reviewers[0].user_id,
//           };
//         }
//         return null;
//       })
//       .filter((rev) => rev !== null);

//     const finalAssignReviewers = assignReviewers;
//     const allDifficultQuestions = selectedSubjects.every((subject) => {
//       const difficulty = difficultyDistributions[subject.subject_id] || {};
//       return (
//         (difficulty.calculatedValue || 0) > 0 &&
//         (difficulty.firstSegment || 0) === 0 &&
//         (difficulty.secondSegment || 0) === 0
//       );
//     });

//     if (allDifficultQuestions) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               Warning: All selected questions are difficult. Consider adjusting the
//               difficulty distribution.
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       await new Promise((resolve) => setTimeout(resolve, 2000));
//     }

//     if (errorMessage) {
//       console.error("Validation Error:", errorMessage);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{errorMessage}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorIcon);
//       return;
//     }

//     if (warningMessage) {
//       console.warn("Warning:", warningMessage);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{warningMessage}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       return;
//     }

//     try {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Processing request, please wait...</span>
//           </div>
//         </div>
//       );
//       setActiveImg(null);

//       // Use the snapshot returned by ensureAllChaptersFetched which includes
//       // chapters fetched just now — state updates are async and would be stale here
//       const resolvedChapters = await ensureAllChaptersFetched();
//       const updatedFormData = {
//         ...formData,
//         subjects: selectedSubjects.map((subject) => ({
//           subject_superset_id: subject.subject_id,
//           easy: difficultyDistributions[subject.subject_id]?.firstSegment || 0,
//           medium: difficultyDistributions[subject.subject_id]?.secondSegment || 0,
//           tough: difficultyDistributions[subject.subject_id]?.calculatedValue || 0,
//           special_inst: specialInstructions[subject.subject_id] || "",
//           chapters: (resolvedChapters[subject.subject_id] || []).map(
//             (chapterId) => ({
//               chapter_id: chapterId,
//             })
//           ),
//         })),
//         assign_creators: assignCreators,
//         assign_reviewers: finalAssignReviewers,
//       };

//       const response = await fetch(`${EndPoints.PRISM_CURATE_QUESTION_PAPER}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           body: JSON.stringify(updatedFormData),
//         }
//       );
//       const responseData = await response.json();
//       const createdPaperId = responseData?.data?.ques_paper_id;

//       setCreatedQuesPaperId(createdPaperId);

//       if (responseData.status === 409) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {responseData.message}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorIcon);
//         return;
//       }

//       if (!response.ok) {
//         throw new Error(
//           responseData.message || `HTTP error! Status: ${response.status}`
//         );
//       }
//       setNoTimeSet(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               Question paper created successfully. Do you want to save this as a pattern?
//             </span>
//           </div>
//           <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//             <button
//               className="messagebox-cancel-btn-ok"
//               onClick={() => {
//                 setIsMessageBoxVisible(false);
//                 setShowPatternPopup(true);
//               }}
//             >
//               YES
//             </button>
//             <button
//               className="messagebox-cancel-btn-ok"
//               onClick={() => {
//                 setIsMessageBoxVisible(false);
//                 setNoTimeSet(false);
//                 setTimeout(() => {
//                   navigate("/assignor_dashboard_details");
//                 }, 500);
//               }}
//             >
//               NO
//             </button>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       setIsMessageBoxVisible(true);

//     } catch (error) {
//       console.error("Error:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               {error.message ||
//                 "An unexpected error occurred. Please try again."}
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   const [patternPopupError, setPatternPopupError] = useState("");

//   const handleCreatePattern = async () => {
//     const isNameEmpty = !patternName.trim();
//     const isDescEmpty = !patternDesc.trim();
//     setPatternNameError(isNameEmpty);
//     setPatternDescError(isDescEmpty);
//     if (isNameEmpty || isDescEmpty) return;
//     try {
//       const encodedName = encodeURIComponent(patternName);
//       const encodedDesc = encodeURIComponent(patternDesc);

//       const response = await fetch(
//         `${EndPoints.PRISM_CHECK_DUPLICATE_LAYOUT}?client_branch_id=${clientBranchId}&username=${userName}&ques_ppr_id=${createdQuesPaperId}&ques_paper_layout_name=${encodedName}&ques_paper_layout_desc=${encodedDesc}`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = await response.json();

//       if (data.status === 404 && data.message === "Duplicate pattern found") {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 <b>Duplicate pattern found</b>: <b>{data.layout_name}</b>
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorIcon);
//         setShowPatternPopup(true);
//         setNoTimeSet(false);
//         return;
//       }

//       if (data.status === 200) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Pattern created successfully!</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setShowPatternPopup(false);
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate("/assignor_dashboard_details");
//         }, 1000);
//       } else {
//         throw new Error(data.message || "Unexpected error");
//       }
//     } catch (error) {
//       console.error("Pattern creation failed:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message || "Failed to create pattern"}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   const handleSpecialInstructionChange = (subjectId, value) => {
//     setSpecialInstructions((prev) => ({
//       ...prev,
//       [subjectId]: value,
//     }));
//   };

//   useEffect(() => {
//     const fetchPatterns = async () => {
//       if (!selectedCourse) {
//         setPatternsData([]);
//         setSelectedPatternDetails(null);
//         setSelectedSubjects([]);
//         return;
//       }

//       try {
//         const response = await fetch(
//           `${EndPoints.PRISM_GET_PATTERN_DETAILS}?course_id=${selectedCourse}`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Failed to fetch pattern details");
//         }

//         const data = await response.json();

//         if (
//           !data ||
//           !Array.isArray(data.question_papers) ||
//           data.question_papers.length === 0
//         ) {
//           setPatternsData([]);
//           setSelectedPatternDetails(null);
//           setSelectedSubjects([]);
//           return;
//         }

//         const formattedPatterns = data.question_papers.map((pattern) => ({
//           id: pattern.ques_paper_layout.ques_paper_layout_id,
//           label: `${pattern.ques_paper_layout.ques_paper_layout_name} - ${pattern.ques_paper_layout.ques_paper_layout_desc}`,
//           details: pattern.ques_paper_details,
//           subjects: pattern.subjects || [],
//         }));

//         setPatternsData(formattedPatterns);
//         setSelectedPatternDetails(formattedPatterns[0]?.details || null);
//         setSelectedSubjects(formattedPatterns[0]?.subjects || []);
//       } catch (error) {
//         setPatternsData([]);
//         setSelectedPatternDetails(null);
//         setSelectedSubjects([]);
//       }
//     };

//     fetchPatterns();
//   }, [selectedCourse, accessToken]);

//   const [testSeriesOptions, setTestSeriesOptions] = useState([]);
//   const [testSeriesData, setTestSeriesData] = useState([]);

//   useEffect(() => {
//     if (!clientBranchId || !selectedCourse || questionPaperType !== 2) {
//       setTestSeriesOptions([]);
//       setTestSeriesData([]);
//       return;
//     }

//     const apiUrl = `${EndPoints.PRISM_GET_TEST_SERIES_LIST_BY_BRANCH}?client_branch_id=${clientBranchId}`;
//     const fetchTestSeries = async () => {
//       try {
//         const response = await fetch(apiUrl, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });
//         const data = await response.json();
//         if (data?.status === 200 && Array.isArray(data.data)) {
//           const filtered = data.data.filter(
//             (item) => item.course_id === selectedCourse
//           );
//           const unique = Array.from(new Map(filtered.map((ts) => [ts.ts_id, ts])).values());
//           const options = unique.map((item) => ({
//             id: item.ts_id,
//             label: `${item.ts_name} - ${item.ts_desc}`,
//           }));
//           setTestSeriesOptions(options);
//           setTestSeriesData(unique);
//         }
//       } catch (err) {
//         console.error("Test series fetch failed", err);
//       }
//     };

//     fetchTestSeries();
//   }, [clientBranchId, selectedCourse, questionPaperType]);

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Curate Question Paper</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={() => { navigate(`/assignor_dashboard_details`); }} >
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSubmit}>
//             SAVE
//           </button>
//         </div>
//       </div>
//       {/* QUESTION PAPER DETAIL Section */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION PAPER DETAIL</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionSubjects}>
//             {isOpenSubject ? ( <div className="minus"></div> ) : ( <div className="plus">+</div> )}
//           </div>
//         </div>
//         {isOpenSubject && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del">
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1">
//                   <DropDown
//                     label="Course"
//                     selected={selectedCourse}
//                     setSelected={(selectedOption) => {
//                       setSelectedCourse(selectedOption || null);
//                       setSelectedClass([]);
//                       setSelectedScope(null);
//                       setSelectedBatch([]);
//                       setSelectedBranch([]);
//                       setSelectedZone([]);
//                       setSelectedCities([]);
//                       setSelectedStates([]);
//                       setSelectedRegion([]);
//                       setSubjects([]);
//                       setCheckedSubjects({});
//                       setExpandedSubjects({});
//                       setSelectedChapters({});
//                       setSpecialInstructions({});
//                       setSelectedTestSeriesID(null);
//                       setTestSeriesOptions([]);
//                       setTestSeriesData([]);
//                       setDifficultyDistributions({});
//                       setTotalQuestionCount(0);
//                       setSelectedCreatorsBySubject({});
//                       setSelectedReviewersBySubject({});
//                       setSelectedPattern(null);
//                       setSelectedPatternDetails(null);
//                       setSelectedSubjects([]);
//                       setFormData((prevFormData) => ({
//                         ...prevFormData,
//                         course_id: selectedOption || null,
//                         classes: [],
//                         subjects: [],
//                         test_series_id: null,
//                         assign_creators: [],
//                         assign_reviewers: [],
//                       }));
//                       setDropdownKey((prev) => prev + 1);
//                     }}
//                     options={
//                       Array.isArray(coursesdata)
//                         ? coursesdata.map((course) => ({
//                             label: course.course_name,
//                             id: course.course_id,
//                           }))
//                         : []
//                     }
//                     isRequired={true}
//                   />
//                 </div>
//                 <div className="item2">
//                   <DropDown
//                     label="Question Paper Type"
//                     selected={questionPaperType}
//                     setSelected={(selectedOption) => {
//                       setQuestionPaperType(selectedOption);

//                       if (selectedOption === 1) {
//                         setSelectedTestSeriesID(null);
//                         setDropdownKey((prev) => prev + 1);

//                         setSelectedClass([]);
//                         setSelectedScope(null);
//                         setSelectedBatch([]);
//                         setSelectedBranch([]);
//                         setSelectedZone([]);
//                         setSelectedCities([]);
//                         setSelectedStates([]);
//                         setSelectedRegion([]);
//                         setCheckedSubjects({});
//                         setExpandedSubjects({});
//                         setSelectedChapters({});
//                         setSpecialInstructions({});
//                         setDifficultyDistributions({});
//                         setTotalQuestionCount(0);
//                         setSelectedCreatorsBySubject({});
//                         setSelectedReviewersBySubject({});
//                         setSelectedPattern(null);
//                         setSelectedPatternDetails(null);
//                         setSelectedSubjects([]);
//                         setSubjects((prev) =>
//                           prev.map((s) => ({
//                             ...s,
//                             questionCount: 0,
//                           }))
//                         );
//                         setFormData((prevFormData) => ({
//                           ...prevFormData,
//                           ques_paper_type: selectedOption,
//                           test_series_id: null,
//                           classes: [],
//                           subjects: [],
//                           assign_creators: [],
//                           assign_reviewers: [],
//                         }));
//                       } else {
//                         setFormData((prev) => ({
//                           ...prev,
//                           ques_paper_type: selectedOption || null,
//                         }));
//                       }
//                     }}
//                     options={[
//                       { id: 1, label: "DPP" },
//                       { id: 2, label: "Test" },
//                     ]}
//                     isRequired={true}
//                   />
//                 </div>
//                 <div className="item2">
//                   <DropDown
//                     label="Test Series"
//                     key={dropdownKey}
//                     selected={selectedtestSeriesId}
//                     setSelected={(selectedOption) => {
//                       setSelectedTestSeriesID(selectedOption);
//                       setFormData((prev) => ({
//                         ...prev,
//                         test_series_id: selectedOption || null,
//                       }));

//                       const fullTS = testSeriesData.find((ts) => ts.ts_id === selectedOption);
//                       if (!fullTS) return;

//                       const classIds = fullTS.class_id_list || [];
//                       setSelectedClass(classIds);
//                       setFormData((prev) => ({ ...prev, classes: classIds }));

//                       setSelectedScope(fullTS.scope_id);
//                       setFormData((prev) => ({
//                         ...prev,
//                         ques_paper_scope_id: fullTS.scope_id,
//                         scope_ref_id: (fullTS.scope_ref_ids || []).map(item => item.id),
//                       }));
//                       switch (fullTS.scope_id) {
//                         case 1:
//                           setSelectedBatch((fullTS.scope_ref_ids || []).map(item => item.id));
//                           break;
//                         case 2:
//                           setSelectedBranch((fullTS.scope_ref_ids || []).map(item => item.id));
//                           break;
//                         case 3:
//                           setSelectedZone((fullTS.scope_ref_ids || []).map(item => item.id));
//                           break;
//                         case 4:
//                           setSelectedCities((fullTS.scope_ref_ids || []).map(item => item.id));
//                           break;
//                         case 5:
//                           setSelectedStates((fullTS.scope_ref_ids || []).map(item => item.id));
//                           break;
//                         case 6:
//                           setSelectedRegion((fullTS.scope_ref_ids || []).map(item => item.id));
//                           break;
//                         default:
//                           break;
//                       }

//                       const checked = {};
//                       const questionCounts = {};
//                       const difficultyMap = {};
//                       const formSubjects = [];
//                       let totalCount = 0;
//                       const subjectMap = {};

//                       (fullTS.subject_section || []).forEach((subj) => {
//                         const subjectId = subj.subject_superset_id || subj.subject_id;
//                         if (!subjectMap[subjectId]) {
//                           subjectMap[subjectId] = {
//                             subject_superset_id: subjectId,
//                             total_question_cnt: 0,
//                             ms_desc: subj.ms_desc || "",
//                           };
//                         }
//                         subjectMap[subjectId].total_question_cnt += subj.total_question_cnt || 0;
//                       });

//                       Object.values(subjectMap).forEach((subj) => {
//                         checked[subj.subject_superset_id] = true;
//                         const count = subj.total_question_cnt || 0;
//                         questionCounts[subj.subject_superset_id] = count;

//                         const easy = Math.floor(count / 3);
//                         const medium = Math.floor(count / 3);
//                         const tough = count - (easy + medium);
//                         difficultyMap[subj.subject_superset_id] = {
//                           firstSegment: easy,
//                           secondSegment: medium,
//                           calculatedValue: tough,
//                         };
//                         totalCount += count;

//                         formSubjects.push({
//                           subject_superset_id: subj.subject_superset_id,
//                           easy,
//                           medium,
//                           tough,
//                           special_inst: subj.ms_desc || "",
//                           chapters: [],
//                         });
//                       });

//                       setCheckedSubjects(checked);
//                       setDifficultyDistributions(difficultyMap);
//                       setTotalQuestionCount(totalCount);
//                       setSubjects((prevSubjects) =>
//                         prevSubjects.map((s) => ({
//                           ...s,
//                           questionCount: questionCounts[s.subject_id] || 0,
//                         }))
//                       );
//                       setFormData((prev) => ({
//                         ...prev,
//                         subjects: formSubjects,
//                       }));

//                       Object.keys(checked).forEach((subjectId) => {
//                         if (chapterData[subjectId]) {
//                           setSelectedChapters((prev) => ({
//                             ...prev,
//                             [subjectId]: chapterData[subjectId].map((ch) => ch.chapter_id),
//                           }));
//                           return;
//                         }
//                         // ─── CHANGED: use subject_superset_id param ───
//                         fetch(
//                           `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`
//                         )
//                           .then((res) => res.json())
//                           .then((data) => {
//                             setChapterData((prev) => ({ ...prev, [subjectId]: data || [] }));
//                             setSelectedChapters((prev) => ({
//                               ...prev,
//                               [subjectId]: (data || []).map((ch) => ch.chapter_id),
//                             }));
//                           })
//                           .catch((e) =>
//                             console.error("Error fetching chapters for subject", subjectId, e)
//                           );
//                       });
//                     }}
//                     options={testSeriesOptions}
//                     disabled={questionPaperType === 1}
//                   />
//                 </div>
//                 <div className="item4">
//                   <FormInputs label="Question Paper Name" value={formData.ques_paper_name}
//                     onChange={(e) => setFormData({ ...formData, ques_paper_name: e.target.value, })}
//                     required />
//                 </div>
//                 <div className="item6">
//                   <FormInputs
//                     label="Due Date"
//                     type="datetime-local"
//                     value={formData.due_date}
//                     onChange={(e) =>
//                       setFormData({ ...formData, due_date: e.target.value })
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="item9">
//                   <DropDown label="Apply Pattern"
//                     setSelected={(selectedOption) => {
//                       setSelectedPattern(selectedOption || null);
//                       const selectedPatternObj = patternsData.find((pattern) => pattern.id === selectedOption);
//                       if (selectedPatternObj) {
//                         const { subjects, details } = selectedPatternObj;
//                         const newCheckedSubjects = {};
//                         const newExpandedSubjects = {};
//                         const newSelectedChapters = {};
//                         const newSpecialInstructions = {};
//                         const newDifficultyDistributions = {};
//                         const newQuestionCounts = {};
//                         const newFormSubjects = [];

//                         let totalQuestions = 0;

//                         subjects.forEach((subj) => {
//                           const subjectId = subj.subject_id;
//                           const easy = subj.easy || 0;
//                           const medium = subj.medium || 0;
//                           const tough = subj.tough || 0;
//                           const total = easy + medium + tough;

//                           newCheckedSubjects[subjectId] = true;
//                           newExpandedSubjects[subjectId] = false;
//                           newSelectedChapters[subjectId] = subj.chapters.map((ch) => ch.chapter_id);
//                           newSpecialInstructions[subjectId] = subj.special_inst || "";
//                           newDifficultyDistributions[subjectId] = {
//                             firstSegment: easy,
//                             secondSegment: medium,
//                             calculatedValue: tough,
//                           };
//                           newQuestionCounts[subjectId] = total;
//                           totalQuestions += total;
//                           newFormSubjects.push({
//                             subject_superset_id: subjectId,
//                             easy,
//                             medium,
//                             tough,
//                             special_inst: subj.special_inst || "",
//                             chapters: subj.chapters || [],
//                           });
//                           if (!chapterData[subjectId]) {
//                             // ─── CHANGED: use subject_superset_id param ───
//                             fetch(
//                               `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`
//                             )
//                               .then((res) => res.json())
//                               .then((data) => {
//                                 setChapterData((prev) => ({
//                                   ...prev,
//                                   [subjectId]: data,
//                                 }));
//                               });
//                           }
//                         });
//                         setCheckedSubjects(newCheckedSubjects);
//                         setExpandedSubjects(newExpandedSubjects);
//                         setSelectedChapters(newSelectedChapters);
//                         setSpecialInstructions(newSpecialInstructions);
//                         setDifficultyDistributions(newDifficultyDistributions);
//                         setTotalQuestionCount(totalQuestions);
//                         setSelectedSubjects(subjects);
//                         setSubjects((prevSubjects) =>
//                           prevSubjects.map((subj) => {
//                             const patternSubj = selectedPatternObj.subjects.find(
//                               (ps) => ps.subject_id === subj.subject_id
//                             );
//                             const isUserModified = manuallyUpdatedSubjects[subj.subject_id];
//                             if (patternSubj && !isUserModified) {
//                               const total =
//                                 (patternSubj.easy || 0) +
//                                 (patternSubj.medium || 0) +
//                                 (patternSubj.tough || 0);
//                               return {
//                                 ...subj,
//                                 questionCount: total,
//                               };
//                             }
//                             return subj;
//                           })
//                         );
//                         setFormData((prevFormData) => ({
//                           ...prevFormData,
//                           total_questions: totalQuestions,
//                           ques_paper_type: details.ques_paper_type || null,
//                           subjects: newFormSubjects,
//                         }));
//                       }
//                     }}
//                     options={
//                       patternsData.length > 0
//                         ? patternsData
//                         : [{ id: "", label: "No Patterns Available" }]
//                     }
//                     minheight="250px"
//                     Height="auto"
//                     OverFlow="auto"
//                     disabled={!!selectedtestSeriesId}
//                   />
//                 </div>
//                 <div className="item7-ques-paper-guideline-del">
//                   <FormInputs
//                     label="Description"
//                     value={formData.description}
//                     onChange={(e) =>
//                       setFormData({ ...formData, description: e.target.value })
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="item7-ques-paper-guideline-del">
//                   <label>Guideline</label>
//                   <textarea
//                     placeholder="Write your guidelines here..."
//                     value={formData.guidelines}
//                     onChange={(e) =>
//                       setFormData({ ...formData, guidelines: e.target.value })
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       {/* SUBJECTS Section */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>SUBJECTS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordion}>
//             {isOpen ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isOpen && (
//           <div className="accordion-content">
//             <div>
//               <table className="table-tc-create-test" style={{ opacity: 0.8 }}>
//                 <thead>
//                   <tr>
//                     <td>Subject/Chapter</td>
//                     <td>Ques Count<span style={{ color: "red", marginLeft: "5px" }}>*</span></td>
//                     <td>Difficulty Level</td>
//                     <td>Assign Creators<span style={{ color: "red", marginLeft: "5px" }}>*</span></td>
//                     <td>Assign Reviewer<span style={{ color: "red", marginLeft: "5px" }}>*</span></td>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {Array.isArray(subjects) && subjects.length > 0 ? (
//                     subjects.map((subject) => {
//                       const isChecked = checkedSubjects[subject.subject_id] || false;
//                       return (
//                         <React.Fragment key={subject.subject_id}>
//                           <tr style={{ height: "62px", opacity: isChecked ? 1 : 0.8, borderBottom: expandedSubjects[subject.subject_id] ? "" : "1px solid #d6d6d6", }}>
//                             <td style={{ width: "12%" }}>
//                               <input type="checkbox" disabled={!!selectedtestSeriesId}
//                                 className="delete-question-checkbox-dqc"
//                                 checked={isChecked}
//                                 onChange={() => handleSubjectCheck(subject.subject_id)}
//                                 style={{ opacity: 1 }}
//                               />
//                               <span
//                                 style={{ marginRight: "6px", cursor: isChecked ? "pointer" : "not-allowed", fontWeight: "bold", opacity: isChecked ? 1 : 0.5, }}
//                                 onClick={() => toggleExpandSubject(subject.subject_id)}
//                               >
//                                 {expandedSubjects[subject.subject_id] ? "−" : "+"}
//                               </span>
//                               {subject.subject_name}
//                             </td>
//                             <td style={{ width: "7%" }}>
//                               <input type="text" className="input-details-nts-cr-test" maxLength={3}
//                                 value={isChecked ? subject.questionCount || "" : ""}
//                                 onChange={(e) => handleQuestionCountChange(subject.subject_id, e.target.value)}
//                                 style={{ opacity: isChecked ? 1 : 0.8 }}
//                                 readOnly={!isChecked || !!selectedtestSeriesId}
//                               />
//                             </td>
//                             <td style={{ width: "30%" }}>
//                               <MultiProgress
//                                 total={isChecked ? parseInt(subject.questionCount, 10) || 0 : 0}
//                                 onSliderChange={(values) => handleSliderChange(subject.subject_id, values)}
//                                 defaultValues={difficultyDistributions[subject.subject_id]}
//                               />
//                             </td>
//                             <td style={{ width: "12%", verticalAlign: "top" }}>
//                               <div className="input-wrapper-column">
//                                 <div className="input-wrapper-top">
//                                   <FacultySelector
//                                     isMultiSelect={true}
//                                     userId={userId}
//                                     selectedSubjectId={subjects}
//                                     isChecked={isChecked}
//                                     onSelectionChange={(selectedFaculties) => {
//                                       setSelectedCreatorsBySubject((prev) => ({
//                                         ...prev,
//                                         [subject.subject_id]: selectedFaculties,
//                                       }));
//                                     }}
//                                     excludeUserIds={(selectedReviewersBySubject[subject.subject_id] || []).map(f => f.user_id)}
//                                   />
//                                   <img
//                                     src={NotesIcon}
//                                     alt="Notes Icon"
//                                     className="outside-icon-notes"
//                                     onClick={() => toggleNotesInput(subject.subject_id)}
//                                     style={{
//                                       cursor: isChecked ? "pointer" : "not-allowed",
//                                       opacity: isChecked ? 1 : 0.5,
//                                     }}
//                                   />
//                                 </div>
//                                 {openNotes[subject.subject_id] && isChecked && (
//                                   <input
//                                     type="text"
//                                     className="assign-notes-input"
//                                     placeholder="Add a note..."
//                                     value={specialInstructions[subject.subject_id] || ""}
//                                     onChange={(e) =>
//                                       handleSpecialInstructionChange(subject.subject_id, e.target.value)
//                                     }
//                                     disabled={!isChecked}
//                                   />
//                                 )}
//                               </div>
//                             </td>
//                             <td style={{ width: "18%" }}>
//                               <div className="input-wrapper" style={{ opacity: isChecked ? 1 : 0.8, position: "relative", }}>
//                                 <FacultySelector
//                                   isMultiSelect={false}
//                                   userId={userId}
//                                   isChecked={isChecked}
//                                   selectedSubjectId={subjects}
//                                   onSelectionChange={(selectedFaculties) => {
//                                     setSelectedReviewersBySubject((prev) => ({
//                                       ...prev,
//                                       [subject.subject_id]: selectedFaculties,
//                                     }));
//                                   }}
//                                   style={{ opacity: isChecked ? 1 : 0.8 }}
//                                   excludeUserIds={
//                                     (selectedCreatorsBySubject[subject.subject_id] || []).map(f => f.user_id)
//                                   }
//                                 />
//                               </div>
//                             </td>
//                           </tr>
//                           {expandedSubjects[subject.subject_id] && (
//                             <tr style={{ borderBottom: "1px solid  #d6d6d6" }}>
//                               <td colSpan="5">
//                                 <div className="chapter-list-create-test">
//                                   <ul>
//                                     <li style={{ marginBottom: "14px" }}>
//                                       <input
//                                         type="checkbox"
//                                         ref={(el) => {
//                                           if (el) {
//                                             const total = chapterData[subject.subject_id]?.length || 0;
//                                             const selected = selectedChapters[subject.subject_id]?.length || 0;
//                                             el.indeterminate = selected > 0 && selected < total;
//                                           }
//                                         }}
//                                         className={
//                                           selectedChapters[subject.subject_id]?.length === chapterData[subject.subject_id]?.length
//                                             ? "delete-question-checkbox-dqc"
//                                             : selectedChapters[subject.subject_id]?.length > 0
//                                               ? "expend-chapt-sub-check-box indeterminate"
//                                               : "expend-chapt-sub-check-box"
//                                         }
//                                         onChange={() => handleSelectAllChapters(subject.subject_id)}
//                                         checked={selectedChapters[subject.subject_id]?.length === chapterData[subject.subject_id]?.length}
//                                       />
//                                       Chapters
//                                     </li>
//                                     {Array.isArray(chapterData[subject.subject_id]) &&
//                                       chapterData[subject.subject_id].length > 0 ? (
//                                       chapterData[subject.subject_id].map((chapter) => (
//                                         <li key={chapter.chapter_id} className="chapter-item-cr-ts">
//                                           <input type="checkbox"
//                                             className="delete-question-checkbox-dqc"
//                                             checked={selectedChapters[subject.subject_id]?.includes(chapter.chapter_id) || false}
//                                             onChange={() => handleChapterCheck(subject.subject_id, chapter.chapter_id)}
//                                           />
//                                           {chapter.chapter_name}
//                                         </li>
//                                       ))
//                                     ) : (
//                                       <div className="chapter-details">
//                                         No chapters available
//                                       </div>
//                                     )}
//                                   </ul>
//                                 </div>
//                               </td>
//                             </tr>
//                           )}
//                         </React.Fragment>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td colSpan="5" style={{ textAlign: "center" }}>
//                         No subjects available
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <div className="total-question-count-cr-test">
//               <span>Total Questions: </span> {totalQuestionCount}
//             </div>
//           </div>
//         )}
//       </div>
//       {showPatternPopup && (
//         <div className="popup-overlay-template-layout">
//           <div className="popup-box-template-layout">
//             <h3>Save as Pattern</h3>
//             <div className="input-wrapper-apply-pattern">
//               <label>Pattern Name</label>
//               <input
//                 type="text"
//                 value={patternName}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   setPatternName(value);
//                   if (patternNameError && value.trim()) { setPatternNameError(false); }
//                 }}
//                 className={patternNameError ? "input-box error-border" : "input-box"}
//                 placeholder="Enter pattern name"
//               />
//               <span className="error-text-pattern">
//                 {patternNameError ? "Pattern name is required." : ""}
//               </span>
//             </div>
//             <div className="input-wrapper-apply-pattern">
//               <label>Pattern Description</label>
//               <input type="text" value={patternDesc}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   setPatternDesc(value);
//                   if (patternDescError && value.trim()) { setPatternDescError(false); }
//                 }}
//                 className={patternDescError ? "input-box error-border" : "input-box"}
//                 placeholder="Enter description"
//               />
//               <span className="error-text-pattern">
//                 {patternDescError ? "Pattern description is required." : ""}
//               </span>
//             </div>
//             {patternPopupError && (
//               <div className="error-text-pattern" style={{ color: "red", marginBottom: "20px" }}>
//                 {patternPopupError}
//               </div>
//             )}
//             <div className="popup-actions-template-layout">
//               <button
//                 className="testreportcard-cancel-btn"
//                 style={{ marginRight: "20px" }}
//                 onClick={() => {
//                   setShowPatternPopup(false);
//                   window.location.reload();
//                 }}
//               >
//                 CANCEL
//               </button>
//               <button
//                 className="testreportcard-cancel-btn"
//                 style={{ width: "120px", marginRight: "0px" }}
//                 onClick={handleCreatePattern}
//               >
//                 SAVE PATTERN
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default CreateQuesPaper;



















import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import "./createques.css";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import SelectedDropdownValues from "./SelectedDropdownValues";
import { fetchClassData } from "../../../Redux/StudentRegistration/classSlice";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import NotesIcon from "./../../../Assets/Images/CommanImages/grommet-icons_notes.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorIcon from "./../../../Assets/Images/CommanImages/Error.png";
import SuccessImg from "./../../../Assets/Images/CommanImages/Informative.png";
import MultiSeledDropdown from "../MultiDropdown/MultiSeledDropdown";
import MultiProgress from "../MultiProgressBar/MultiProgress";
import { fetchScopeData } from "../../../Redux/Scope/ScopeSlice";
import { API_BASE_URL } from "../../../Config/Config";
import FacultySelector from "../MultipleAssignCreator/FacultySelector";
import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
import EndPoints from "../../../Api/Endpoints";
import { POST, GET } from "../../../Api/HttpsMethods";

function CreateQuesPaper({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg, setNoTimeSet, }) {
  const [questionPaperType, setQuestionPaperType] = useState(null);
  const [selectedtestSeriesId, setSelectedTestSeriesID] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { coursesdata = [] } = useSelector((state) => state.course) || {};
  const { classData = [] } = useSelector((state) => state.classname) || {};
  const { scopeData = [] } = useSelector((state) => state.scopes) || {};
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedClass, setSelectedClass] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [chapterData, setChapterData] = useState({});
  const [checkedSubjects, setCheckedSubjects] = useState({});
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenSubject, setIsOpenSubject] = useState(true);
  const [totalQuestionCount, setTotalQuestionCount] = useState(0);
  const [QuestionTypeId, setQuestionTypeID] = useState(null);
  const [selectedChapters, setSelectedChapters] = useState({});
  const [difficultyDistributions, setDifficultyDistributions] = useState({});
  const [selectScope, setSelectedScope] = useState(null);
  const [openNotes, setOpenNotes] = useState({});
  const [batchData, setBatchData] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [selectedFaculties, setSelectedFaculties] = useState([]);
  const [selectedAssigReviewerFaculties, setSelectedAssigReviewerFaculties] = useState([]);
  const [selectedCreatorsBySubject, setSelectedCreatorsBySubject] = useState({});
  const [selectedReviewersBySubject, setSelectedReviewersBySubject] = useState({});
  const [dropdownKey, setDropdownKey] = useState(0);
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const userId = dataClient && dataClient.client_schema_name[6][0].user_id;
  const [specialInstructions, setSpecialInstructions] = useState({});
  const [patternsData, setPatternsData] = useState([]);
  const [selectedPatternDetails, setSelectedPatternDetails] = useState(null);
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [createdQuesPaperId, setCreatedQuesPaperId] = useState(null);
  const accessToken = localStorage.getItem("other");
  const [patternNameError, setPatternNameError] = useState(false);
  const [patternDescError, setPatternDescError] = useState(false);

  // ✅ Ref to cache subject_id → subject_superset_id mapping
  // Built once when subjects are fetched for a course; avoids re-fetching on test series select.
  // Needed because test series subject_section uses raw subject_id (1,2,3,4) but chapters
  // must be fetched using subject_superset_id (Botany id=3 and Zoology id=4 both map to superset id=3)
  const subjectIdToSupersetIdRef = useRef({});

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      client_branch_id: clientBranchId,
      created_by: userName,
    }));
  }, [clientBranchId, userName]);

  const [showPatternPopup, setShowPatternPopup] = useState(false);
  const [patternName, setPatternName] = useState("");
  const [patternDesc, setPatternDesc] = useState("");

  useEffect(() => {
    dispatch(fetchClassData());
    dispatch(fetchCourseData());
    dispatch(fetchScopeData());
  }, [dispatch]);


  useEffect(() => {
    const fetchSubjectsByCourse = async () => {
      if (!selectedCourse) {
        setSubjects([]);
        // ✅ Clear mapping when course is cleared
        subjectIdToSupersetIdRef.current = {};
        return;
      }
      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourse}`;
        const data = await GET.withToken(API_ENDPOINT);

        if (!Array.isArray(data)) {
          setSubjects([]);
          subjectIdToSupersetIdRef.current = {};
          return;
        }

        // ✅ Cache full subject_id → subject_superset_id mapping from raw API response
        // This is the only place we have both ids together; store it for use when
        // a test series is selected later (test series only provides subject_id)
        subjectIdToSupersetIdRef.current = {};
        data.forEach((item) => {
          subjectIdToSupersetIdRef.current[item.subject_id] = item.subject_superset_id;
        });

        // Deduplicate by subject_superset_id; map superset fields onto subject_id/subject_name
        // so all downstream state, handlers, and POST payload automatically use subject_superset_id
        const seen = new Set();
        const deduplicated = data.reduce((acc, item) => {
          if (!seen.has(item.subject_superset_id)) {
            seen.add(item.subject_superset_id);
            acc.push({
              subject_id: item.subject_superset_id,
              subject_name: item.subject_superset_name,
              subject_desc: item.subject_superset_desc,
            });
          }
          return acc;
        }, []);

        setSubjects(deduplicated);
      } catch (error) {
        console.error("Error fetching subjects:", error);
        setSubjects([]);
        subjectIdToSupersetIdRef.current = {};
      }
    };
    fetchSubjectsByCourse();
  }, [selectedCourse]);


  const handleSubjectCheck = async (subjectId) => {
    let shouldFetchChapters = false;
    setCheckedSubjects((prev) => {
      const isChecked = !prev[subjectId];
      const chapters = chapterData[subjectId] || [];

      if (isChecked) {
        setSelectedChapters((prevChapters) => ({
          ...prevChapters,
          [subjectId]: chapters.map((ch) => ch.chapter_id),
        }));

        setFormData((prevFormData) => {
          const existingSubject = prevFormData.subjects.find(
            (s) => s.subject_superset_id === subjectId
          );

          let easy = 0,
            medium = 0,
            tough = 0;

          if (questionPaperType === 2) {
            easy = difficultyDistributions[subjectId]?.firstSegment || 0;
            medium = difficultyDistributions[subjectId]?.secondSegment || 0;
            tough = difficultyDistributions[subjectId]?.calculatedValue || 0;
          }

          return {
            ...prevFormData,
            subjects: [
              ...prevFormData.subjects.filter(
                (s) => s.subject_superset_id !== subjectId
              ),
              {
                subject_superset_id: subjectId,
                easy,
                medium,
                tough,
                special_inst: existingSubject?.special_inst || "",
                chapters: chapters.map((ch) => ({
                  chapter_id: ch.chapter_id,
                })),
              },
            ],
          };
        });
      } else {
        setSelectedChapters((prevChapters) => ({
          ...prevChapters,
          [subjectId]: [],
        }));

        setExpandedSubjects((prevExpanded) => ({
          ...prevExpanded,
          [subjectId]: false,
        }));

        setFormData((prevFormData) => ({
          ...prevFormData,
          subjects: prevFormData.subjects.filter(
            (s) => s.subject_superset_id !== subjectId
          ),
        }));
      }

      if (!chapterData[subjectId]) {
        shouldFetchChapters = true;
      }

      return { ...prev, [subjectId]: isChecked };
    });

    if (!shouldFetchChapters) return;

    try {
      const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`;
      const data = await GET.withToken(API_ENDPOINT);

      if (!Array.isArray(data)) {
        console.error("Expected array but got:", data);
        return;
      }

      setChapterData((prev) => ({
        ...prev,
        [subjectId]: data,
      }));

      setSelectedChapters((prevChapters) => ({
        ...prevChapters,
        [subjectId]: data.map((ch) => ch.chapter_id),
      }));
    } catch (error) {
      console.error("Error fetching chapters:", error);
    }
  };


  const toggleExpandSubject = async (subjectId) => {
    if (!checkedSubjects[subjectId]) return;
    setExpandedSubjects((prev) => ({
      ...prev,
      [subjectId]: !prev[subjectId],
    }));

    if (chapterData[subjectId]) return;

    try {
      const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`;
      const data = await GET.withToken(API_ENDPOINT);

      if (!Array.isArray(data)) {
        console.error("Expected array but got:", data);
        return;
      }

      setChapterData((prev) => ({
        ...prev,
        [subjectId]: data,
      }));

      setSelectedChapters((prevChapters) => ({
        ...prevChapters,
        [subjectId]: data.map((ch) => ch.chapter_id),
      }));
    } catch (error) {
      console.error("Error fetching chapters:", error);
    }
  };

  const syncSubjectFromChapters = (subjectId, nextChapterIds) => {
    setCheckedSubjects((prev) => ({
      ...prev,
      [subjectId]: nextChapterIds.length > 0,
    }));
    setFormData((prev) => {
      const filtered = prev.subjects.filter((s) => s.subject_superset_id !== subjectId);

      if (nextChapterIds.length === 0) {
        return { ...prev, subjects: filtered };
      }
      const existing = prev.subjects.find((s) => s.subject_superset_id === subjectId);
      const dist = difficultyDistributions[subjectId] || {};
      return {
        ...prev,
        subjects: [
          ...filtered,
          {
            subject_superset_id: subjectId,
            easy: existing?.easy ?? dist.firstSegment ?? 0,
            medium: existing?.medium ?? dist.secondSegment ?? 0,
            tough: existing?.tough ?? dist.calculatedValue ?? 0,
            special_inst: existing?.special_inst ?? specialInstructions[subjectId] ?? "",
            chapters: nextChapterIds.map((id) => ({ chapter_id: id })),
          },
        ],
      };
    });
  };


  const handleChapterCheck = (subjectId, chapterId) => {
    setSelectedChapters((prev) => {
      const current = prev[subjectId] || [];
      const next = current.includes(chapterId)
        ? current.filter((id) => id !== chapterId)
        : [...current, chapterId];
      syncSubjectFromChapters(subjectId, next);

      return { ...prev, [subjectId]: next };
    });
  };

  const handleSelectAllChapters = (subjectId) => {
    const total = chapterData[subjectId]?.length || 0;
    const allSelected = (selectedChapters[subjectId]?.length || 0) === total;

    const next = allSelected
      ? []
      : chapterData[subjectId].map((ch) => ch.chapter_id);

    setSelectedChapters((prev) => ({ ...prev, [subjectId]: next }));
    syncSubjectFromChapters(subjectId, next);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const toggleAccordionSubjects = () => {
    setIsOpenSubject(!isOpenSubject);
  };

  const [manuallyUpdatedSubjects, setManuallyUpdatedSubjects] = useState({});

  const handleQuestionCountChange = (subjectId, value) => {
    if (/^\d*$/.test(value)) {
      const parsedValue = parseInt(value || 0, 10);

      setManuallyUpdatedSubjects((prev) => ({
        ...prev,
        [subjectId]: true,
      }));

      setSubjects((prevSubjects) =>
        prevSubjects.map((subject) =>
          subject.subject_id === subjectId
            ? { ...subject, questionCount: parsedValue }
            : subject
        )
      );

      const easy = Math.floor(parsedValue / 3);
      const medium = Math.floor(parsedValue / 3);
      const tough = parsedValue - (easy + medium);

      const newDistribution = {
        firstSegment: easy,
        secondSegment: medium,
        calculatedValue: tough,
      };

      setDifficultyDistributions((prev) => ({
        ...prev,
        [subjectId]: newDistribution,
      }));

      setFormData((prevFormData) => {
        const updatedSubjects = prevFormData.subjects.map((subject) => {
          if (subject.subject_superset_id === subjectId) {
            return {
              ...subject,
              easy,
              medium,
              tough,
            };
          }
          return subject;
        });

        return {
          ...prevFormData,
          subjects: updatedSubjects,
        };
      });

      const newTotal = subjects.reduce((acc, subject) => {
        const count =
          subject.subject_id === subjectId
            ? parsedValue
            : parseInt(subject.questionCount || 0, 10);
        return acc + count;
      }, 0);
      setTotalQuestionCount(newTotal);
    }
  };


  const handleSliderChange = (subjectId, values) => {
    setDifficultyDistributions((prev) => ({
      ...prev,
      [subjectId]: values,
    }));

    setFormData((prevFormData) => {
      const updatedSubjects = prevFormData.subjects.map((subject) => {
        if (subject.subject_superset_id === subjectId) {
          return {
            ...subject,
            easy: values.firstSegment || 0,
            medium: values.secondSegment || 0,
            tough: values.calculatedValue || 0,
          };
        }
        return subject;
      });

      return {
        ...prevFormData,
        subjects: updatedSubjects,
      };
    });
  };

  const toggleNotesInput = (subjectId) => {
    if (!checkedSubjects[subjectId]) return;
    setOpenNotes((prev) => ({
      ...prev,
      [subjectId]: !prev[subjectId],
    }));

    if (!specialInstructions[subjectId]) {
      setSpecialInstructions((prev) => ({
        ...prev,
        [subjectId]: "",
      }));
    }
  };

  const [formData, setFormData] = useState({
    ques_paper_name: "",
    description: "",
    ques_paper_type: QuestionTypeId,
    course_id: selectedCourse,
    ques_paper_series: selectedPattern,
    due_date: "",
    test_series_id: selectedtestSeriesId,
    client_branch_id: clientBranchId,
    created_by: userName,
    status: 1,
    guidelines: "",
    classes: selectedClass,
    subjects: [
      {
        subject_superset_id: 0,
        easy: 0,
        medium: 0,
        tough: 0,
        special_inst: "",
        chapters: [],
      },
    ],
    assign_creators: [
      {
        subject_superset_id: 0,
        user_ids: selectedFaculties.map((faculty) => faculty.user_id),
      },
    ],
    assign_reviewers: [
      { subject_superset_id: 0, user_id: selectedAssigReviewerFaculties.user_id },
    ],
  });


  const ensureAllChaptersFetched = async () => {
    const resolvedChapters = { ...selectedChapters };

    const subjectIdsToFetch = Object.keys(checkedSubjects)
      .filter((sid) => checkedSubjects[sid])
      .filter((sid) => !chapterData[sid]);

    const promises = subjectIdsToFetch.map(async (sid) => {
      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${sid}`;
        const data = await GET.withToken(API_ENDPOINT);
        const chapters = Array.isArray(data) ? data : [];
        const chapterIds = chapters.map((c) => c.chapter_id);

        setChapterData((prev) => ({ ...prev, [sid]: chapters }));
        setSelectedChapters((prev) => ({ ...prev, [sid]: chapterIds }));

        resolvedChapters[sid] = chapterIds;
      } catch (error) {
        console.error(`Error fetching chapters for subject ${sid}:`, error);
        setChapterData((prev) => ({ ...prev, [sid]: [] }));
        setSelectedChapters((prev) => ({ ...prev, [sid]: [] }));
        resolvedChapters[sid] = [];
      }
    });

    await Promise.all(promises);

    return resolvedChapters;
  };

  const handleSubmit = async () => {
    let errorMessage = "";
    let warningMessage = "";

    if (!formData.course_id) {
      errorMessage = "Course selection is required.";
    } else if (!formData.ques_paper_type) {
      errorMessage = "Question Paper Type is required.";
    } else if (!formData.ques_paper_name) {
      errorMessage = "Test Name is required.";
    } else if (!formData.due_date) {
      errorMessage = "Due Date is required.";
    } else if (!formData.description) {
      errorMessage = "Description is required.";
    } else {
      const dueDate = new Date(formData.due_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      dueDate.setHours(0, 0, 0, 0);

      if (isNaN(dueDate.getTime())) {
        errorMessage = "Please enter a valid due date.";
      } else if (dueDate < today) {
        errorMessage = "Question paper due date cannot be in the past.";
      }
    }

    const selectedSubjects = subjects.filter(
      (subject) => checkedSubjects[subject.subject_id]
    );
    if (!errorMessage && selectedSubjects.length === 0) {
      errorMessage = "At least one subject must be selected.";
    }

    const hasZeroQuestionCount = selectedSubjects.some(
      (subject) => (parseInt(subject.questionCount, 10) || 0) === 0
    );
    if (!errorMessage && hasZeroQuestionCount) {
      errorMessage = "Question count cannot be zero for any selected subject.";
    }

    const hasLessThanThreeQuestions = selectedSubjects.some(
      (subject) => {
        const count = parseInt(subject.questionCount, 10) || 0;
        return count > 0 && count < 3;
      }
    );

    if (!errorMessage && hasLessThanThreeQuestions) {
      errorMessage = "Question count must be at least 3 for each selected subject.";
    }

    if (!errorMessage && formData.ques_paper_type === 1) {
      const hasExcessiveDPP = selectedSubjects.some(
        (subject) => (parseInt(subject.questionCount, 10) || 0) > 50
      );

      if (hasExcessiveDPP) {
        warningMessage +=
          (warningMessage ? "\n" : "") +
          "DPP should not have more than 50 questions per subject.";
      }
    }

    const assignCreators = selectedSubjects.map((subject) => ({
      subject_superset_id: subject.subject_id,
      user_ids: (selectedCreatorsBySubject[subject.subject_id] || []).map(
        (faculty) => faculty.user_id
      ),
    }));

    const hasSubjectWithoutCreator = assignCreators.some(
      (subject) => subject.user_ids.length === 0
    );
    if (!errorMessage && hasSubjectWithoutCreator) {
      errorMessage =
        "Each selected subject must have at least one assigned creator.";
    }

    const hasSubjectWithoutReviewer = selectedSubjects.some(
      (subject) => {
        const reviewers = selectedReviewersBySubject[subject.subject_id] || [];
        return reviewers.length === 0;
      }
    );

    if (!errorMessage && hasSubjectWithoutReviewer) {
      errorMessage = "Please assign at least one reviewer to each selected subject.";
    }

    const assignReviewers = selectedSubjects
      .map((subject) => {
        const reviewers = selectedReviewersBySubject[subject.subject_id] || [];
        if (reviewers.length > 0) {
          return {
            subject_superset_id: subject.subject_id,
            user_id: reviewers[0].user_id,
          };
        }
        return null;
      })
      .filter((rev) => rev !== null);

    const finalAssignReviewers = assignReviewers;
    const allDifficultQuestions = selectedSubjects.every((subject) => {
      const difficulty = difficultyDistributions[subject.subject_id] || {};
      return (
        (difficulty.calculatedValue || 0) > 0 &&
        (difficulty.firstSegment || 0) === 0 &&
        (difficulty.secondSegment || 0) === 0
      );
    });

    if (allDifficultQuestions) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Warning: All selected questions are difficult. Consider adjusting the
              difficulty distribution.
            </span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      await new Promise((resolve) => setTimeout(resolve, 2000));
    }

    if (errorMessage) {
      console.error("Validation Error:", errorMessage);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{errorMessage}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }

    if (warningMessage) {
      console.warn("Warning:", warningMessage);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{warningMessage}</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      return;
    }

    try {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Processing request, please wait...</span>
          </div>
        </div>
      );
      setActiveImg(null);

      const resolvedChapters = await ensureAllChaptersFetched();
      const updatedFormData = {
        ...formData,
        subjects: selectedSubjects.map((subject) => ({
          subject_superset_id: subject.subject_id,
          easy: difficultyDistributions[subject.subject_id]?.firstSegment || 0,
          medium: difficultyDistributions[subject.subject_id]?.secondSegment || 0,
          tough: difficultyDistributions[subject.subject_id]?.calculatedValue || 0,
          special_inst: specialInstructions[subject.subject_id] || "",
          chapters: (resolvedChapters[subject.subject_id] || []).map(
            (chapterId) => ({
              chapter_id: chapterId,
            })
          ),
        })),
        assign_creators: assignCreators,
        assign_reviewers: finalAssignReviewers,
      };

      const response = await fetch(`${EndPoints.PRISM_CURATE_QUESTION_PAPER}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(updatedFormData),
        }
      );
      const responseData = await response.json();
      const createdPaperId = responseData?.data?.ques_paper_id;

      setCreatedQuesPaperId(createdPaperId);

      if (responseData.status === 409) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {responseData.message}
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorIcon);
        return;
      }

      if (!response.ok) {
        throw new Error(
          responseData.message || `HTTP error! Status: ${response.status}`
        );
      }
      setNoTimeSet(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1" style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
            <div className="loader-tc"></div>
            <span>
              Question paper created successfully. Do you want to save this as a pattern?
            </span>
          </div>
          <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                setShowPatternPopup(true);
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                setNoTimeSet(false);
                setTimeout(() => {
                  navigate("/assignor_dashboard_details");
                }, 500);
              }}
            >
              NO
            </button>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      setIsMessageBoxVisible(true);

    } catch (error) {
      console.error("Error:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              {error.message ||
                "An unexpected error occurred. Please try again."}
            </span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
    }
  };

  const [patternPopupError, setPatternPopupError] = useState("");

  const handleCreatePattern = async () => {
    const isNameEmpty = !patternName.trim();
    const isDescEmpty = !patternDesc.trim();
    setPatternNameError(isNameEmpty);
    setPatternDescError(isDescEmpty);
    if (isNameEmpty || isDescEmpty) return;
    try {
      const encodedName = encodeURIComponent(patternName);
      const encodedDesc = encodeURIComponent(patternDesc);

      const response = await fetch(
        `${EndPoints.PRISM_CHECK_DUPLICATE_LAYOUT}?client_branch_id=${clientBranchId}&username=${userName}&ques_ppr_id=${createdQuesPaperId}&ques_paper_layout_name=${encodedName}&ques_paper_layout_desc=${encodedDesc}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (data.status === 404 && data.message === "Duplicate pattern found") {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                <b>Duplicate pattern found</b>: <b>{data.layout_name}</b>
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorIcon);
        setShowPatternPopup(true);
        setNoTimeSet(false);
        return;
      }

      if (data.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Pattern created successfully!</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setShowPatternPopup(false);
        setTimeout(() => {
          setIsMessageBoxVisible(false);
          navigate("/assignor_dashboard_details");
        }, 1000);
      } else {
        throw new Error(data.message || "Unexpected error");
      }
    } catch (error) {
      console.error("Pattern creation failed:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{error.message || "Failed to create pattern"}</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
    }
  };

  const handleSpecialInstructionChange = (subjectId, value) => {
    setSpecialInstructions((prev) => ({
      ...prev,
      [subjectId]: value,
    }));
  };

  useEffect(() => {
    const fetchPatterns = async () => {
      if (!selectedCourse) {
        setPatternsData([]);
        setSelectedPatternDetails(null);
        setSelectedSubjects([]);
        return;
      }

      try {
        const response = await fetch(
          `${EndPoints.PRISM_GET_PATTERN_DETAILS}?course_id=${selectedCourse}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch pattern details");
        }

        const data = await response.json();

        if (
          !data ||
          !Array.isArray(data.question_papers) ||
          data.question_papers.length === 0
        ) {
          setPatternsData([]);
          setSelectedPatternDetails(null);
          setSelectedSubjects([]);
          return;
        }

        const formattedPatterns = data.question_papers.map((pattern) => ({
          id: pattern.ques_paper_layout.ques_paper_layout_id,
          label: `${pattern.ques_paper_layout.ques_paper_layout_name} - ${pattern.ques_paper_layout.ques_paper_layout_desc}`,
          details: pattern.ques_paper_details,
          subjects: pattern.subjects || [],
        }));

        setPatternsData(formattedPatterns);
        setSelectedPatternDetails(formattedPatterns[0]?.details || null);
        setSelectedSubjects(formattedPatterns[0]?.subjects || []);
      } catch (error) {
        setPatternsData([]);
        setSelectedPatternDetails(null);
        setSelectedSubjects([]);
      }
    };

    fetchPatterns();
  }, [selectedCourse, accessToken]);

  const [testSeriesOptions, setTestSeriesOptions] = useState([]);
  const [testSeriesData, setTestSeriesData] = useState([]);

  useEffect(() => {
    if (!clientBranchId || !selectedCourse || questionPaperType !== 2) {
      setTestSeriesOptions([]);
      setTestSeriesData([]);
      return;
    }

    const apiUrl = `${EndPoints.PRISM_GET_TEST_SERIES_LIST_BY_BRANCH}?client_branch_id=${clientBranchId}`;
    const fetchTestSeries = async () => {
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const data = await response.json();
        if (data?.status === 200 && Array.isArray(data.data)) {
          const filtered = data.data.filter(
            (item) => item.course_id === selectedCourse
          );
          const unique = Array.from(new Map(filtered.map((ts) => [ts.ts_id, ts])).values());
          const options = unique.map((item) => ({
            id: item.ts_id,
            label: `${item.ts_name} - ${item.ts_desc}`,
          }));
          setTestSeriesOptions(options);
          setTestSeriesData(unique);
        }
      } catch (err) {
        console.error("Test series fetch failed", err);
      }
    };

    fetchTestSeries();
  }, [clientBranchId, selectedCourse, questionPaperType]);

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Curate Question Paper</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={() => { navigate(`/assignor_dashboard_details`); }} >
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSubmit}>
            SAVE
          </button>
        </div>
      </div>
      {/* QUESTION PAPER DETAIL Section */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION PAPER DETAIL</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionSubjects}>
            {isOpenSubject ? ( <div className="minus"></div> ) : ( <div className="plus">+</div> )}
          </div>
        </div>
        {isOpenSubject && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del">
              <div className="grid-container-ques-paper-del">
                <div className="item1">
                  <DropDown
                    label="Course"
                    selected={selectedCourse}
                    setSelected={(selectedOption) => {
                      setSelectedCourse(selectedOption || null);
                      setSelectedClass([]);
                      setSelectedScope(null);
                      setSelectedBatch([]);
                      setSelectedBranch([]);
                      setSelectedZone([]);
                      setSelectedCities([]);
                      setSelectedStates([]);
                      setSelectedRegion([]);
                      setSubjects([]);
                      setCheckedSubjects({});
                      setExpandedSubjects({});
                      setSelectedChapters({});
                      setSpecialInstructions({});
                      setSelectedTestSeriesID(null);
                      setTestSeriesOptions([]);
                      setTestSeriesData([]);
                      setDifficultyDistributions({});
                      setTotalQuestionCount(0);
                      setSelectedCreatorsBySubject({});
                      setSelectedReviewersBySubject({});
                      setSelectedPattern(null);
                      setSelectedPatternDetails(null);
                      setSelectedSubjects([]);
                      // ✅ Clear mapping when course changes
                      subjectIdToSupersetIdRef.current = {};
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        course_id: selectedOption || null,
                        classes: [],
                        subjects: [],
                        test_series_id: null,
                        assign_creators: [],
                        assign_reviewers: [],
                      }));
                      setDropdownKey((prev) => prev + 1);
                    }}
                    options={
                      Array.isArray(coursesdata)
                        ? coursesdata.map((course) => ({
                            label: course.course_name,
                            id: course.course_id,
                          }))
                        : []
                    }
                    isRequired={true}
                  />
                </div>
                <div className="item2">
                  <DropDown
                    label="Question Paper Type"
                    selected={questionPaperType}
                    setSelected={(selectedOption) => {
                      setQuestionPaperType(selectedOption);

                      if (selectedOption === 1) {
                        setSelectedTestSeriesID(null);
                        setDropdownKey((prev) => prev + 1);

                        setSelectedClass([]);
                        setSelectedScope(null);
                        setSelectedBatch([]);
                        setSelectedBranch([]);
                        setSelectedZone([]);
                        setSelectedCities([]);
                        setSelectedStates([]);
                        setSelectedRegion([]);
                        setCheckedSubjects({});
                        setExpandedSubjects({});
                        setSelectedChapters({});
                        setSpecialInstructions({});
                        setDifficultyDistributions({});
                        setTotalQuestionCount(0);
                        setSelectedCreatorsBySubject({});
                        setSelectedReviewersBySubject({});
                        setSelectedPattern(null);
                        setSelectedPatternDetails(null);
                        setSelectedSubjects([]);
                        setSubjects((prev) =>
                          prev.map((s) => ({
                            ...s,
                            questionCount: 0,
                          }))
                        );
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          ques_paper_type: selectedOption,
                          test_series_id: null,
                          classes: [],
                          subjects: [],
                          assign_creators: [],
                          assign_reviewers: [],
                        }));
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          ques_paper_type: selectedOption || null,
                        }));
                      }
                    }}
                    options={[
                      { id: 1, label: "DPP" },
                      { id: 2, label: "Test" },
                    ]}
                    isRequired={true}
                  />
                </div>
                <div className="item2">
                  <DropDown
                    label="Test Series"
                    key={dropdownKey}
                    selected={selectedtestSeriesId}
                    setSelected={async (selectedOption) => {
                      setSelectedTestSeriesID(selectedOption);
                      setFormData((prev) => ({
                        ...prev,
                        test_series_id: selectedOption || null,
                      }));

                      const fullTS = testSeriesData.find((ts) => ts.ts_id === selectedOption);
                      if (!fullTS) return;

                      const classIds = fullTS.class_id_list || [];
                      setSelectedClass(classIds);
                      setFormData((prev) => ({ ...prev, classes: classIds }));

                      setSelectedScope(fullTS.scope_id);
                      setFormData((prev) => ({
                        ...prev,
                        ques_paper_scope_id: fullTS.scope_id,
                        scope_ref_id: (fullTS.scope_ref_ids || []).map(item => item.id),
                      }));
                      switch (fullTS.scope_id) {
                        case 1:
                          setSelectedBatch((fullTS.scope_ref_ids || []).map(item => item.id));
                          break;
                        case 2:
                          setSelectedBranch((fullTS.scope_ref_ids || []).map(item => item.id));
                          break;
                        case 3:
                          setSelectedZone((fullTS.scope_ref_ids || []).map(item => item.id));
                          break;
                        case 4:
                          setSelectedCities((fullTS.scope_ref_ids || []).map(item => item.id));
                          break;
                        case 5:
                          setSelectedStates((fullTS.scope_ref_ids || []).map(item => item.id));
                          break;
                        case 6:
                          setSelectedRegion((fullTS.scope_ref_ids || []).map(item => item.id));
                          break;
                        default:
                          break;
                      }

                      const checked = {};
                      const questionCounts = {};
                      const difficultyMap = {};
                      const formSubjects = [];
                      let totalCount = 0;
                      const subjectMap = {};

                      // ✅ FIX: Resolve subject_id → subject_superset_id using the cached ref
                      // Test series subject_section only has raw subject_id (e.g. 1,2,3,4).
                      // Botany (subject_id=3) and Zoology (subject_id=4) both belong to
                      // superset Biology (subject_superset_id=3). Without this resolution,
                      // id=4 would be used as a key and chapters would be fetched for
                      // subject_superset_id=4 which doesn't exist → "Not authenticated" / 404.
                      // (fullTS.subject_section || []).forEach((subj) => {
                      //   const resolvedSupersetId =
                      //     subjectIdToSupersetIdRef.current[subj.subject_id] ?? subj.subject_id;

                      //   if (!subjectMap[resolvedSupersetId]) {
                      //     subjectMap[resolvedSupersetId] = {
                      //       subject_superset_id: resolvedSupersetId,
                      //       total_question_cnt: 0,
                      //       ms_desc: subj.ms_desc || "",
                      //     };
                      //   }
                      //   // Accumulate question counts across sections of the same superset
                      //   subjectMap[resolvedSupersetId].total_question_cnt += subj.total_question_cnt || 0;
                      // });
                      // AFTER (fixed):
                      (fullTS.subject_section || []).forEach((subj) => {
                        const supersetId = subj.subject_superset_id; // ✅ use the correct field directly

                        if (!subjectMap[supersetId]) {
                          subjectMap[supersetId] = {
                            subject_superset_id: supersetId,
                            total_question_cnt: 0,
                            ms_desc: subj.ms_desc || "",
                          };
                        }
                        subjectMap[supersetId].total_question_cnt += subj.total_question_cnt || 0;
                      });

                      Object.values(subjectMap).forEach((subj) => {
                        checked[subj.subject_superset_id] = true;
                        const count = subj.total_question_cnt || 0;
                        questionCounts[subj.subject_superset_id] = count;

                        const easy = Math.floor(count / 3);
                        const medium = Math.floor(count / 3);
                        const tough = count - (easy + medium);
                        difficultyMap[subj.subject_superset_id] = {
                          firstSegment: easy,
                          secondSegment: medium,
                          calculatedValue: tough,
                        };
                        totalCount += count;

                        formSubjects.push({
                          subject_superset_id: subj.subject_superset_id,
                          easy,
                          medium,
                          tough,
                          special_inst: subj.ms_desc || "",
                          chapters: [],
                        });
                      });

                      setCheckedSubjects(checked);
                      setDifficultyDistributions(difficultyMap);
                      setTotalQuestionCount(totalCount);
                      setSubjects((prevSubjects) =>
                        prevSubjects.map((s) => ({
                          ...s,
                          questionCount: questionCounts[s.subject_id] || 0,
                        }))
                      );
                      setFormData((prev) => ({
                        ...prev,
                        subjects: formSubjects,
                      }));

                      // ✅ FIX: Use GET.withToken() with Promise.all instead of raw fetch()
                      // Keys in 'checked' are already resolved superset ids (1, 2, 3 — never 4)
                      // so chapter fetches will only fire for valid superset ids
                      const chapterFetchPromises = Object.keys(checked).map(async (subjectId) => {
                        if (chapterData[subjectId]) {
                          setSelectedChapters((prev) => ({
                            ...prev,
                            [subjectId]: chapterData[subjectId].map((ch) => ch.chapter_id),
                          }));
                          return;
                        }
                        try {
                          const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`;
                          const data = await GET.withToken(API_ENDPOINT);
                          const chapters = Array.isArray(data) ? data : [];
                          setChapterData((prev) => ({ ...prev, [subjectId]: chapters }));
                          setSelectedChapters((prev) => ({
                            ...prev,
                            [subjectId]: chapters.map((ch) => ch.chapter_id),
                          }));
                        } catch (e) {
                          console.error("Error fetching chapters for subject", subjectId, e);
                          setChapterData((prev) => ({ ...prev, [subjectId]: [] }));
                          setSelectedChapters((prev) => ({ ...prev, [subjectId]: [] }));
                        }
                      });

                      await Promise.all(chapterFetchPromises);
                    }}
                    options={testSeriesOptions}
                    disabled={questionPaperType === 1}
                  />
                </div>
                <div className="item4">
                  <FormInputs label="Question Paper Name" value={formData.ques_paper_name}
                    onChange={(e) => setFormData({ ...formData, ques_paper_name: e.target.value, })}
                    required />
                </div>
                <div className="item6">
                  <FormInputs
                    label="Due Date"
                    type="datetime-local"
                    value={formData.due_date}
                    onChange={(e) =>
                      setFormData({ ...formData, due_date: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="item9">
                  <DropDown label="Apply Pattern"
                    setSelected={async (selectedOption) => {
                      setSelectedPattern(selectedOption || null);
                      const selectedPatternObj = patternsData.find((pattern) => pattern.id === selectedOption);
                      if (selectedPatternObj) {
                        const { subjects, details } = selectedPatternObj;
                        const newCheckedSubjects = {};
                        const newExpandedSubjects = {};
                        const newSelectedChapters = {};
                        const newSpecialInstructions = {};
                        const newDifficultyDistributions = {};
                        const newQuestionCounts = {};
                        const newFormSubjects = [];

                        let totalQuestions = 0;

                        // ✅ FIX: Changed from subjects.forEach to for...of to support await,
                        // and replaced raw fetch() with GET.withToken()
                        for (const subj of subjects) {
                          const subjectId = subj.subject_id;
                          const easy = subj.easy || 0;
                          const medium = subj.medium || 0;
                          const tough = subj.tough || 0;
                          const total = easy + medium + tough;

                          newCheckedSubjects[subjectId] = true;
                          newExpandedSubjects[subjectId] = false;
                          newSelectedChapters[subjectId] = subj.chapters.map((ch) => ch.chapter_id);
                          newSpecialInstructions[subjectId] = subj.special_inst || "";
                          newDifficultyDistributions[subjectId] = {
                            firstSegment: easy,
                            secondSegment: medium,
                            calculatedValue: tough,
                          };
                          newQuestionCounts[subjectId] = total;
                          totalQuestions += total;
                          newFormSubjects.push({
                            subject_superset_id: subjectId,
                            easy,
                            medium,
                            tough,
                            special_inst: subj.special_inst || "",
                            chapters: subj.chapters || [],
                          });

                          if (!chapterData[subjectId]) {
                            try {
                              const API_ENDPOINT = `${EndPoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${subjectId}`;
                              const data = await GET.withToken(API_ENDPOINT);
                              setChapterData((prev) => ({
                                ...prev,
                                [subjectId]: Array.isArray(data) ? data : [],
                              }));
                            } catch (e) {
                              console.error("Error fetching chapters for subject", subjectId, e);
                              setChapterData((prev) => ({ ...prev, [subjectId]: [] }));
                            }
                          }
                        }

                        setCheckedSubjects(newCheckedSubjects);
                        setExpandedSubjects(newExpandedSubjects);
                        setSelectedChapters(newSelectedChapters);
                        setSpecialInstructions(newSpecialInstructions);
                        setDifficultyDistributions(newDifficultyDistributions);
                        setTotalQuestionCount(totalQuestions);
                        setSelectedSubjects(subjects);
                        setSubjects((prevSubjects) =>
                          prevSubjects.map((subj) => {
                            const patternSubj = selectedPatternObj.subjects.find(
                              (ps) => ps.subject_id === subj.subject_id
                            );
                            const isUserModified = manuallyUpdatedSubjects[subj.subject_id];
                            if (patternSubj && !isUserModified) {
                              const total =
                                (patternSubj.easy || 0) +
                                (patternSubj.medium || 0) +
                                (patternSubj.tough || 0);
                              return {
                                ...subj,
                                questionCount: total,
                              };
                            }
                            return subj;
                          })
                        );
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          total_questions: totalQuestions,
                          ques_paper_type: details.ques_paper_type || null,
                          subjects: newFormSubjects,
                        }));
                      }
                    }}
                    options={
                      patternsData.length > 0
                        ? patternsData
                        : [{ id: "", label: "No Patterns Available" }]
                    }
                    minheight="250px"
                    Height="auto"
                    OverFlow="auto"
                    disabled={!!selectedtestSeriesId}
                  />
                </div>
                <div className="item7-ques-paper-guideline-del">
                  <FormInputs
                    label="Description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="item7-ques-paper-guideline-del">
                  <label>Guideline</label>
                  <textarea
                    placeholder="Write your guidelines here..."
                    value={formData.guidelines}
                    onChange={(e) =>
                      setFormData({ ...formData, guidelines: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* SUBJECTS Section */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>SUBJECTS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordion}>
            {isOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="accordion-content">
            <div>
              <table className="table-tc-create-test" style={{ opacity: 0.8 }}>
                <thead>
                  <tr>
                    <td>Subject/Chapter</td>
                    <td>Ques Count<span style={{ color: "red", marginLeft: "5px" }}>*</span></td>
                    <td>Difficulty Level</td>
                    <td>Assign Creators<span style={{ color: "red", marginLeft: "5px" }}>*</span></td>
                    <td>Assign Reviewer<span style={{ color: "red", marginLeft: "5px" }}>*</span></td>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(subjects) && subjects.length > 0 ? (
                    subjects.map((subject) => {
                      const isChecked = checkedSubjects[subject.subject_id] || false;
                      return (
                        <React.Fragment key={subject.subject_id}>
                          <tr style={{ height: "62px", opacity: isChecked ? 1 : 0.8, borderBottom: expandedSubjects[subject.subject_id] ? "" : "1px solid #d6d6d6", }}>
                            <td style={{ width: "12%" }}>
                              <input type="checkbox" disabled={!!selectedtestSeriesId}
                                className="delete-question-checkbox-dqc"
                                checked={isChecked}
                                onChange={() => handleSubjectCheck(subject.subject_id)}
                                style={{ opacity: 1 }}
                              />
                              <span
                                style={{ marginRight: "6px", cursor: isChecked ? "pointer" : "not-allowed", fontWeight: "bold", opacity: isChecked ? 1 : 0.5, }}
                                onClick={() => toggleExpandSubject(subject.subject_id)}
                              >
                                {expandedSubjects[subject.subject_id] ? "−" : "+"}
                              </span>
                              {subject.subject_name}
                            </td>
                            <td style={{ width: "7%" }}>
                              <input type="text" className="input-details-nts-cr-test" maxLength={3}
                                value={isChecked ? subject.questionCount || "" : ""}
                                onChange={(e) => handleQuestionCountChange(subject.subject_id, e.target.value)}
                                style={{ opacity: isChecked ? 1 : 0.8 }}
                                readOnly={!isChecked || !!selectedtestSeriesId}
                              />
                            </td>
                            <td style={{ width: "30%" }}>
                              <MultiProgress
                                total={isChecked ? parseInt(subject.questionCount, 10) || 0 : 0}
                                onSliderChange={(values) => handleSliderChange(subject.subject_id, values)}
                                defaultValues={difficultyDistributions[subject.subject_id]}
                              />
                            </td>
                            <td style={{ width: "12%", verticalAlign: "top" }}>
                              <div className="input-wrapper-column">
                                <div className="input-wrapper-top">
                                  <FacultySelector
                                    isMultiSelect={true}
                                    userId={userId}
                                    selectedSubjectId={subjects}
                                    isChecked={isChecked}
                                    onSelectionChange={(selectedFaculties) => {
                                      setSelectedCreatorsBySubject((prev) => ({
                                        ...prev,
                                        [subject.subject_id]: selectedFaculties,
                                      }));
                                    }}
                                    excludeUserIds={(selectedReviewersBySubject[subject.subject_id] || []).map(f => f.user_id)}
                                  />
                                  <img
                                    src={NotesIcon}
                                    alt="Notes Icon"
                                    className="outside-icon-notes"
                                    onClick={() => toggleNotesInput(subject.subject_id)}
                                    style={{
                                      cursor: isChecked ? "pointer" : "not-allowed",
                                      opacity: isChecked ? 1 : 0.5,
                                    }}
                                  />
                                </div>
                                {openNotes[subject.subject_id] && isChecked && (
                                  <input
                                    type="text"
                                    className="assign-notes-input"
                                    placeholder="Add a note..."
                                    value={specialInstructions[subject.subject_id] || ""}
                                    onChange={(e) =>
                                      handleSpecialInstructionChange(subject.subject_id, e.target.value)
                                    }
                                    disabled={!isChecked}
                                  />
                                )}
                              </div>
                            </td>
                            <td style={{ width: "18%" }}>
                              <div className="input-wrapper" style={{ opacity: isChecked ? 1 : 0.8, position: "relative", }}>
                                <FacultySelector
                                  isMultiSelect={false}
                                  userId={userId}
                                  isChecked={isChecked}
                                  selectedSubjectId={subjects}
                                  onSelectionChange={(selectedFaculties) => {
                                    setSelectedReviewersBySubject((prev) => ({
                                      ...prev,
                                      [subject.subject_id]: selectedFaculties,
                                    }));
                                  }}
                                  style={{ opacity: isChecked ? 1 : 0.8 }}
                                  excludeUserIds={
                                    (selectedCreatorsBySubject[subject.subject_id] || []).map(f => f.user_id)
                                  }
                                />
                              </div>
                            </td>
                          </tr>
                          {expandedSubjects[subject.subject_id] && (
                            <tr style={{ borderBottom: "1px solid  #d6d6d6" }}>
                              <td colSpan="5">
                                <div className="chapter-list-create-test">
                                  <ul>
                                    <li style={{ marginBottom: "14px" }}>
                                      <input
                                        type="checkbox"
                                        ref={(el) => {
                                          if (el) {
                                            const total = chapterData[subject.subject_id]?.length || 0;
                                            const selected = selectedChapters[subject.subject_id]?.length || 0;
                                            el.indeterminate = selected > 0 && selected < total;
                                          }
                                        }}
                                        className={
                                          selectedChapters[subject.subject_id]?.length === chapterData[subject.subject_id]?.length
                                            ? "delete-question-checkbox-dqc"
                                            : selectedChapters[subject.subject_id]?.length > 0
                                              ? "expend-chapt-sub-check-box indeterminate"
                                              : "expend-chapt-sub-check-box"
                                        }
                                        onChange={() => handleSelectAllChapters(subject.subject_id)}
                                        checked={selectedChapters[subject.subject_id]?.length === chapterData[subject.subject_id]?.length}
                                      />
                                      Chapters
                                    </li>
                                    {Array.isArray(chapterData[subject.subject_id]) &&
                                      chapterData[subject.subject_id].length > 0 ? (
                                      chapterData[subject.subject_id].map((chapter) => (
                                        <li key={chapter.chapter_id} className="chapter-item-cr-ts">
                                          <input type="checkbox"
                                            className="delete-question-checkbox-dqc"
                                            checked={selectedChapters[subject.subject_id]?.includes(chapter.chapter_id) || false}
                                            onChange={() => handleChapterCheck(subject.subject_id, chapter.chapter_id)}
                                          />
                                          {chapter.chapter_name}
                                        </li>
                                      ))
                                    ) : (
                                      <div className="chapter-details">
                                        No chapters available
                                      </div>
                                    )}
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        No subjects available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="total-question-count-cr-test">
              <span>Total Questions: </span> {totalQuestionCount}
            </div>
          </div>
        )}
      </div>
      {showPatternPopup && (
        <div className="popup-overlay-template-layout">
          <div className="popup-box-template-layout">
            <h3>Save as Pattern</h3>
            <div className="input-wrapper-apply-pattern">
              <label>Pattern Name</label>
              <input
                type="text"
                value={patternName}
                onChange={(e) => {
                  const value = e.target.value;
                  setPatternName(value);
                  if (patternNameError && value.trim()) { setPatternNameError(false); }
                }}
                className={patternNameError ? "input-box error-border" : "input-box"}
                placeholder="Enter pattern name"
              />
              <span className="error-text-pattern">
                {patternNameError ? "Pattern name is required." : ""}
              </span>
            </div>
            <div className="input-wrapper-apply-pattern">
              <label>Pattern Description</label>
              <input type="text" value={patternDesc}
                onChange={(e) => {
                  const value = e.target.value;
                  setPatternDesc(value);
                  if (patternDescError && value.trim()) { setPatternDescError(false); }
                }}
                className={patternDescError ? "input-box error-border" : "input-box"}
                placeholder="Enter description"
              />
              <span className="error-text-pattern">
                {patternDescError ? "Pattern description is required." : ""}
              </span>
            </div>
            {patternPopupError && (
              <div className="error-text-pattern" style={{ color: "red", marginBottom: "20px" }}>
                {patternPopupError}
              </div>
            )}
            <div className="popup-actions-template-layout">
              <button
                className="testreportcard-cancel-btn"
                style={{ marginRight: "20px" }}
                onClick={() => {
                  setShowPatternPopup(false);
                  window.location.reload();
                }}
              >
                CANCEL
              </button>
              <button
                className="testreportcard-cancel-btn"
                style={{ width: "120px", marginRight: "0px" }}
                onClick={handleCreatePattern}
              >
                SAVE PATTERN
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateQuesPaper;